module.exports = __webpack_public_path__ + "static/media/MySQL.592dfec0.jpg";